import PanguSideModal from './panguSideModal.vue'
export default PanguSideModal
